import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { FormConsortiumKeys } from './types'

interface Schema {
    id: FormConsortiumKeys
}

export const FormConsortiumValue: {
    input?: InputBuildProps & Schema
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'cotaConsorcio',
            label: 'Cota do consórcio',
            placeholder: '-'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'numeroGrupo',
            label: 'Nº do grupo',
            placeholder: '-'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
